module.exports = __webpack_public_path__ + "public/img/xs.875426d9.png";